import { CSSProperties } from 'react';
import { getDinamicCSSTypes } from '../../../../helpers/dinamicTyping';

const baseCSS: CSSProperties = {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
};

export const feedbackComponentContainerStyle = getDinamicCSSTypes({
  desktop: {
    ...baseCSS,
    minHeight: '100%',
  },
  mobile: {
    ...baseCSS,
    minHeight: '90%',
  },
});
